import { useParams } from "react-router-dom";
import { isTaskSetGeoLocation } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { SendGeoPage } from "./SendGeoPage";

const SendGeo = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskSetGeoLocation(currentTask) || !currentPoint) {
        return <NotFound />;
    }

    return <SendGeoPage point={currentPoint} task={currentTask} />;
};

export default SendGeo;
